export default __webpack_public_path__ + "images/d151024dc79a4dcf637e5f5684606d1b.png";